module.exports = __webpack_public_path__ + "img/_super_03.edd709ba.jpg";